export enum DefaultLookupCode {
  RegMode = "REGMODE",
  TestReason = "REASON",
  ExpTime = "EXPIRATION",
  FAAEmployee = "FAAEMPLOYEE",
  DOTSampleType = "DOTSAMPLE",
  NonDOTSampleType = "NONDOTSAMPLE",
}
